// Auto-generated by scripts/write-build-info.js — DO NOT EDIT.
// Regenerated on every build/deploy. Gitignored.
const BUILD_INFO = {
  "sha": "d10e4e84e6cc5324c4e96f7b622fcbe97aae36e7",
  "shaShort": "d10e4e8",
  "branch": "main",
  "time": "2026-11-05T09:08:49.762Z"
};

module.exports = BUILD_INFO;
module.exports.default = BUILD_INFO;
